export var RBColor;
(function (RBColor) {
    RBColor[RBColor["Red"] = 0] = "Red";
    RBColor[RBColor["Black"] = 1] = "Black";
})(RBColor || (RBColor = {}));
//# sourceMappingURL=rbColor.js.map